import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["animated", "popoverBlock", "direction", "increasedTouchZone", "refCallback", "opened", "dataQaType", "className", "onClick", "align", "variant"];
import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import dataQa from '@platform-ui/dataQa';
import styles from './Popover.module.css';
const PopoverBlock = props => {
  const {
      animated,
      popoverBlock,
      direction,
      increasedTouchZone,
      refCallback,
      opened,
      dataQaType,
      className,
      align,
      variant = 'desktop'
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const [mounted, setMounted] = useState(false);
  const [animationDisabled, setAnimationDisabled] = useState(true);
  const handleAnimationEnd = useCallback(event => {
    if (event.target !== event.currentTarget) return;
    if (!opened) setMounted(false);
  }, [opened]);
  const handleAnimationStart = useCallback(() => setAnimationDisabled(false), []);
  useEffect(() => {
    const withoutAnimation = animationDisabled || !animated;
    if (opened) {
      setMounted(true);
    }
    if (!opened && withoutAnimation) {
      setMounted(false);
    }
  }, [opened, animated, animationDisabled]);
  return mounted ? /*#__PURE__*/React.createElement("div", Object.assign({}, otherProps, dataQa({
    dataQaType
  }), {
    ref: refCallback,
    className: cn({
      [styles.container]: true,
      [styles.container_animated]: animated,
      [styles[`container_direction_${direction}`]]: direction,
      [styles[`container_align_${align}`]]: align,
      [styles[`container_variant_${variant}`]]: variant,
      [styles.container_open]: opened && direction,
      [styles.container_close]: !opened && direction
    }, className),
    onAnimationStart: handleAnimationStart,
    onAnimationEnd: handleAnimationEnd
  }), increasedTouchZone && /*#__PURE__*/React.createElement("div", Object.assign({
    className: styles.touchzone,
    style: _extends({}, increasedTouchZone)
  }, dataQa({
    dataQaType: `${dataQaType}.touchzone`
  }))), popoverBlock) : null;
};
export default PopoverBlock;